// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__FRfs4"};